import { configureStore } from "@reduxjs/toolkit";
import labReducer from "./labSlice";
export default configureStore({
  reducer: {
    lab: labReducer,
  },
  //   devTools: process?.env?.NODE_ENV !== "production",
});
